import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_SEARCH_V2_MAINTENANCE = createFcmDetails('search_v2_maintenance', {
	owner: 'Site Platform',
	context: 'Search page v2',
	description: `
		Determines whether the new search page v2 is in maintenance mode.

		This flag allows us to safely perform maintenance on the Typesense server for specific locales without impacting other regions.
	`,
	import: false,
});
